import { createRoot } from "react-dom/client";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";
import App from "./App.tsx";
import "./index.css";
import { hasAnalyticsConsent } from "./lib/cookieConsent";
import { setupGlobalErrorHandlers } from "./lib/errorLogger";
import { validateEnvVars } from "./lib/envCheck";
import { initializeGA4 } from "./lib/gtag";

// Validate environment variables early
validateEnvVars();

// Setup global error handlers for production error tracking
setupGlobalErrorHandlers();

// Initialize Google Analytics 4
initializeGA4();

// Initialize PostHog (respect cookie consent: opt-out until user accepts)
const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    person_profiles: "identified_only",
  });
  if (!hasAnalyticsConsent()) {
    posthog.opt_out_capturing();
  }
}

createRoot(document.getElementById("root")!).render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>
);
